<div class="flex flex-col gap-4">
  <div class="flex items-start justify-between gap-4">
    <h2 class="m-0 text-lg font-bold text-midnight">Add supplemental entry</h2>
    <button type="button" mat-dialog-close aria-label="Close dialog">
      <img src="assets/icons/close.svg" alt="Close" class="w-4 h-4" />
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="grid gap-4">
    <div class="relative">
      <label for="message" class="font-medium text-midnight">Note </label>
      <textarea
        formControlName="note"
        class="w-full px-6 py-3 font-medium border rounded-lg focus:outline-midnight text-midnight"
        name="message"
        rows="4"
        id="message"
      ></textarea>
      <!-- Required error -->
      @if (form.controls.note.touched &&
      form.controls.note.hasError('required')) {
      <span class="absolute left-6 error -bottom-5 text-error"
        >Note is required</span
      >
      }
    </div>

    @if (error(); as err) {
    <p class="text-error m-0">{{ err }}</p>
    }

    <div class="flex flex-wrap justify-end gap-4">
      <button
        type="button"
        class="normal-case rounded-full btn btn-outline min-w-[184px] text-base"
        mat-dialog-close
        [disabled]="isLoading()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="normal-case rounded-full btn btn-primary min-w-[184px] text-base"
        [class.pointer-events-none]="isLoading()"
      >
        @if (isLoading()) {
        <et-atoms-spinner size="small"></et-atoms-spinner>
        } @else { Save }
      </button>
    </div>
  </form>
</div>
